import {
  Grid2,
} from '@mui/material';
import { FC } from 'react';
import { TeamComparisonChart } from './TeamComparisonChart';
import { TopTeamsByHoursChart } from './TopTeamsByHoursChart';
import { TeamOrdersDonutChart } from './TeamOrdersDonutChart';
import { TSingleTeam } from '../../../../types';
import { BestSalesmanTable } from './BestSalesmanByTeam';

type CommissionModel = 'split' | 'duplicate' | 'team steps';

type TTeamStat = {
  id: number;
  name: string;
  model: CommissionModel;
  netSales: number;
  commission: number;
  memberCount: number;
  totalOrders: number;
  members: TSingleTeam['team']['members']
};

type TAllTeamsAnalytics = {
  teamStats: TTeamStat[];
};

const AllTeamsAnalytics: FC<TAllTeamsAnalytics> = ({ teamStats }) => (
  <Grid2 container spacing={2}>
    <Grid2
      size={{
        sm: 12, xs: 12, md: 12, lg: 12,
      }}
    >
      <TeamComparisonChart teams={teamStats} />
    </Grid2>
    <Grid2
      size={{
        sm: 12, xs: 6, md: 6, lg: 6,
      }}
    >
      <BestSalesmanTable teamStats={teamStats} />
    </Grid2>
    <Grid2
      size={{
        sm: 12, xs: 6, md: 6, lg: 6,
      }}
    >
      <TeamOrdersDonutChart teams={teamStats} />
    </Grid2>
    <Grid2
      size={{
        sm: 12, xs: 12, md: 12, lg: 12,
      }}
    >
      <TopTeamsByHoursChart teams={teamStats} />
    </Grid2>
  </Grid2>
);

export { AllTeamsAnalytics };
